<iframe frameBorder="0" [src]="patientAppUrl" class="windowClass"></iframe>
